import { useMutation } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const useCheckout = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: { price_id: string }) => apiClient.payments.checkout({ requestBody }),
  });

  return {
    ...mutation,
    getCheckoutUrl: mutation.mutate,
    getCheckoutUrlAsync: mutation.mutateAsync,
  };
};
